import jQuery from "jquery";
import "./scriptLoader";
import "./eventsManager";

// search.js (widgets.reservamos.mx) still calls helpers removed in jQuery 4.
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.trim = (text) => (text == null ? "" : String(text).trim());
jQuery.isFunction = (obj) => typeof obj === "function";

window.$ = jQuery;
window.jQuery = jQuery;
